var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgW4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_3_",
    "data-name": "calendar (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(53.585 27.96)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M63.281,5.859H59.473V2.93a2.93,2.93,0,0,0-5.859,0v2.93H40.283V2.93a2.93,2.93,0,0,0-5.859,0v2.93H21.24V2.93a2.93,2.93,0,1,0-5.859,0v2.93H11.719A11.732,11.732,0,0,0,0,17.578v45.7A11.732,11.732,0,0,0,11.719,75H34.131a2.93,2.93,0,0,0,0-5.859H11.719a5.866,5.866,0,0,1-5.859-5.859v-45.7a5.866,5.866,0,0,1,5.859-5.859h3.662v2.93a2.93,2.93,0,1,0,5.859,0v-2.93H34.424v2.93a2.93,2.93,0,0,0,5.859,0v-2.93h13.33v2.93a2.93,2.93,0,0,0,5.859,0v-2.93h3.809a5.866,5.866,0,0,1,5.859,5.859v16.7a2.93,2.93,0,0,0,5.859,0v-16.7A11.732,11.732,0,0,0,63.281,5.859Z",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M287.725,270a17.725,17.725,0,1,0,17.725,17.725A17.745,17.745,0,0,0,287.725,270Zm0,29.59a11.865,11.865,0,1,1,11.865-11.865A11.879,11.879,0,0,1,287.725,299.59Z",
    transform: "translate(-230.449 -230.449)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M378.178,336.006h-1.318V332.93a2.93,2.93,0,0,0-5.859,0v6.006a2.93,2.93,0,0,0,2.93,2.93h4.248a2.93,2.93,0,0,0,0-5.859Z",
    transform: "translate(-316.654 -281.66)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(40.756 27.96)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(28.256 40.46)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(15.427 27.96)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(15.427 40.46)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(15.427 53.289)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(28.256 53.289)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(28.256 27.96)",
    fill: "#f4805a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW4);
export default __webpack_public_path__ + "static/media/W4.848ff271f3007a4fcb79b62f4ebe66f2.svg";
export { ForwardRef as ReactComponent };